import { render, staticRenderFns } from "./PlanoDataTable.vue?vue&type=template&id=29ad5848"
import script from "./PlanoDataTable.vue?vue&type=script&lang=ts"
export * from "./PlanoDataTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports